import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import {
    documentActions,
    downloadActions,
    errorActions,
    filterActions,
    loadingActions,
    profileActions,
    userActions
} from '../actions';

@Injectable()
export class LoadingEffects {
    private actions$ = inject(Actions);

    startLoading$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                ...[
                    userActions.getUser,
                    documentActions.getDrive,
                    documentActions.getFavourites,
                    documentActions.getRecentlySeen,
                    documentActions.selectDrive,
                    documentActions.searchFiles,
                    downloadActions.downloadFile,
                    downloadActions.downloadSnippetFile,
                    profileActions.getUserProfiles,
                    filterActions.changeFilter
                ]
            ),
            concatMap((action) => of(loadingActions.addLoading({ actionType: action.type })))
        )
    );

    stopLoading$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                ...[
                    userActions.getUserSuccess,
                    userActions.createInitialUserSuccess,
                    documentActions.getDriveSuccess,
                    documentActions.getFavouritesSuccess,
                    documentActions.getRecentlySeenSuccess,
                    documentActions.getAllDrivesSuccess,
                    documentActions.searchFilesSuccess,
                    documentActions.searchFilesFailure,
                    downloadActions.getFileFailure,
                    downloadActions.saveFile,
                    downloadActions.fileSentByEmailSuccess,
                    profileActions.getUserProfilesSuccess,
                    profileActions.createInitialProfileSuccess
                ]
            ),
            concatMap(() => of(loadingActions.stopLoading()))
        )
    );

    forceStopLoading$ = createEffect(() =>
        this.actions$.pipe(
            ofType(...[errorActions.addError]),
            concatMap(() => of(loadingActions.forcesStopLoading()))
        )
    );
}
